import React from "react";

const INPUT_BASE = {
  width: "100%",
  padding: "7px 10px",
  borderRadius: 7,
  fontSize: 12,
  color: "#334155",
  outline: "none",
  fontFamily: "inherit",
  boxSizing: "border-box",
  transition: "border-color 0.15s",
};

const DateRow = ({ row, index, onChange, onDelete }) => {
  const inputStyle = {
    ...INPUT_BASE,
    border: `1px solid ${row.conflict ? "#fca5a5" : "#e2e8f0"}`,
    background: row.conflict ? "#fff5f5" : "#fff",
  };

  return (
    <tr
      style={{
        background: row.conflict ? "#fff5f5" : index % 2 === 0 ? "#fff" : "#fafafa",
        borderBottom: "1px solid #f1f5f9",
      }}
    >
      {/* Start Date */}
      <td style={{ padding: "8px 10px", verticalAlign: "middle" }}>
        <input
          type="date"
          value={row.startDate}
          onChange={(e) => onChange(index, "startDate", e.target.value)}
          style={inputStyle}
          onFocus={(e) => (e.currentTarget.style.borderColor = row.conflict ? "#f87171" : "#6366f1")}
          onBlur={(e) =>
            (e.currentTarget.style.borderColor = row.conflict ? "#fca5a5" : "#e2e8f0")
          }
        />
      </td>

      {/* End Date */}
      <td style={{ padding: "8px 10px", verticalAlign: "middle" }}>
        <input
          type="date"
          value={row.endDate}
          onChange={(e) => onChange(index, "endDate", e.target.value)}
          style={inputStyle}
          onFocus={(e) => (e.currentTarget.style.borderColor = row.conflict ? "#f87171" : "#6366f1")}
          onBlur={(e) =>
            (e.currentTarget.style.borderColor = row.conflict ? "#fca5a5" : "#e2e8f0")
          }
        />
      </td>

      {/* Notes */}
      <td style={{ padding: "8px 10px", verticalAlign: "middle" }}>
        <input
          type="text"
          placeholder="Add a note…"
          value={row.notes}
          onChange={(e) => onChange(index, "notes", e.target.value)}
          style={inputStyle}
          onFocus={(e) => (e.currentTarget.style.borderColor = row.conflict ? "#f87171" : "#6366f1")}
          onBlur={(e) =>
            (e.currentTarget.style.borderColor = row.conflict ? "#fca5a5" : "#e2e8f0")
          }
        />
        {row.conflict && (
          <div
            style={{
              marginTop: 4,
              fontSize: 10,
              color: "#dc2626",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            <i className="fa fa-exclamation-circle" />
            Resource already booked for this date. Choose another date or resource.
          </div>
        )}
      </td>

      {/* Actions */}
      <td style={{ padding: "8px 10px", verticalAlign: "middle", textAlign: "center" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <button
            title="Edit"
            style={{
              border: "none",
              background: "none",
              cursor: "pointer",
              color: "#6366f1",
              fontSize: 14,
              padding: 3,
              lineHeight: 1,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#4f46e5")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#6366f1")}
          >
            <i className="fa fa-pencil" />
          </button>
          <button
            title="Delete"
            onClick={() => onDelete(index)}
            style={{
              border: "none",
              background: "none",
              cursor: "pointer",
              color: "#ef4444",
              fontSize: 14,
              padding: 3,
              lineHeight: 1,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#dc2626")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#ef4444")}
          >
            <i className="fa fa-trash" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default DateRow;